/**
 * WEB-3956 юнит 8 — раздел маршрутов «витрины»: витрины кита и графа воронки.
 * `router/index.tsx` подключает раздел только вне боевой сборки (ветка
 * `!import.meta.env.PROD`, Vite вырезает её в бою); сторож —
 * `router/__tests__/kitRoute.web3310.test.ts`.
 */
import type { RouteObject } from 'react-router-dom';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { FirstSuspense } from '../suspense';

// WEB-640 (FULLSWEEP §0): dev-only витрина кита компонентов — на неё qa-pilot
// делает mockup-diff (§10) против канона «Кит компонентов.dc.html».
const KitDemoPage = lazyWithRetry(
  () => import('@/pages/KitDemo'),
  'page:KitDemo',
);
// WEB-3310: витрина кита кабинета нового вида (только сборка разработки и
// только при флаге черновика кабинета — проверяет сама страница).
const KitDsPage = lazyWithRetry(
  () => import('@/pages/KitDs'),
  'page:KitDs',
);
// WEB-2825: витрина графа воронки (только сборка разработки) — сверка с
// макетом «Граф воронки.dc.html» и показ владельцу до встраивания в мастер.
const KitDemoFunnelGraphPage = lazyWithRetry(
  () => import('@/pages/KitDemoFunnelGraph'),
  'page:KitDemoFunnelGraph',
);

export const KIT_ROUTES: RouteObject[] = [
  {
    path: '/kit-demo',
    element: <FirstSuspense><KitDemoPage /></FirstSuspense>,
  },
  {
    path: '/kit',
    element: <FirstSuspense><KitDsPage /></FirstSuspense>,
  },
  {
    path: '/kit-demo/funnel-graph',
    element: <FirstSuspense><KitDemoFunnelGraphPage /></FirstSuspense>,
  },
];
